import { Typography } from '@material-ui/core';
import React, { memo } from 'react';

const NoticeProductPending = () => {
  return (
    <Typography variant='subtitle2' display='block'>
      Seu produto ainda não foi aprovado na moderação, para iniciar as vendas é necessário que o mesmo esteja aprovado.
    </Typography>
  );
};

export default memo(NoticeProductPending);
